const ANDROID_CHANNEL_ID = '';

const initializeNotificationChannel = async (): Promise<void> => {};

const initializeNotificationHandler = (): void => {};

export { ANDROID_CHANNEL_ID, initializeNotificationChannel, initializeNotificationHandler };
